!function (root, factory) {

    factory(root, root.app, root.jQuery);

}(this, function (root, app, $) {

    var overwatch = root.overwatch;
    var video = overwatch.video;
    var lightbox = overwatch.lightbox;

    function Helpers() {

        $(document.body).on("click", "[data-js=lightbox-hook]", function (e) {
            var $element, id, $lightboxContent, html, options;
            $element = $(e.target);
            id = $element.data("target");
            options = $element.data("options") || {};
            if (typeof id !== "undefined") {
                $lightboxContent = $("[data-js=lightbox-content][data-id=" + id + "]");
            }
            if ($lightboxContent.length > 0) {
                html = $lightboxContent.html();
                options.body = html;
                overwatch.lightbox.open(options);
            }
        });

        this.loadVideoIntoFrame = function loadVideoIntoFrame(videoId, options) {
            options = (typeof options === 'undefined') ? {} : options;

            var v = video.create({ elem: $('<div video>'), id: videoId }, function (video) {
                video.player.playVideo();
            });

            lightbox.open({ body: v.$root });

            overwatch.lightbox.one('hide', function () {
                v.destroy();
                lightbox.empty();
                options.closeCallback && options.closeCallback();
            });

        };

        this.loadImageIntoFrame = function loadImageIntoFrame(imgSrc, classOverride) {
            var classes = classOverride ? 'u-bg-center' + " " + classOverride : 'u-bg-cover u-bg-center';
            overwatch.lightbox.open({
                body: $('<a>', {
                    href: imgSrc,
                    target: "_blank",
                    style: 'background-image:url("' + imgSrc + '")',
                    addClass: classes
                }),
                media: true
            });
        };

        this.userLoggedIn = function() {
            return $(document.body).hasClass("is-logged-in");
        };
    };

    app.extend({ helpers: new Helpers() });

    return app.helpers;

});
